/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Trans, withI18n } from '@lingui/react'


export default class OpenTime extends Component {

  constructor(props) {
    super(props);
    this.state = {
      day: null
    };
    this.openHours = this.openHours.bind(this);
  }

  componentDidMount() {
        var today = new Date();
        var day = today.getDay();

        this.setState({
            day: day
          });
          console.log('open hours updated for: ' + day);
      return this.openHours(this.props.closingDay, this.props.dayOn,this.props.dayOff);


  }
  /* 3 is wednesday */
  openHours(closingDay, dayOn, dayOff){
    var txt = this.state.day === closingDay ?
      <div id="closedOrOpenInner">
      <span className="icon is-small"><i className="fas fa-clock red" aria-hidden="true"></i></span>
       <span className="infoDate red"><Trans id='closed today'/></span>
       </div>
       :
       <div>
       <span className="icon is-small"><i className="fas fa-clock green" aria-hidden="true"></i></span>
       <span className="infoDate green"> {' ' + dayOn + 'H - ' + dayOff + 'H'}</span>
       </div>

    return txt;
  }


    render() {
      return(
          this.openHours(this.props.closingDay, this.props.dayOn,this.props.dayOff)
      )
    }
  }
  OpenTime.propTypes = {

  };



// WEBPACK FOOTER //
// ./src/components/OpenTime/index.js